import { FC } from 'react';

import { TermsPolicy } from 'pages/public/components/common';
import { BsFillCheckCircleFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';

const Success: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="relative h-full">
      <div className="text-center mt-[279px]">
        <BsFillCheckCircleFill className="text-primary-base text-[83px] m-auto mb-[30px]" />
        <div className="space-y-2 mb-[22px]">
          <h3 className="text-xl font-semibold">Password Changed</h3>
          <p className="text-sm">
            Your password has been changed successfully.
          </p>
        </div>
        <Button
          size="lg"
          label="BACK TO LOGIN"
          type="button"
          className="font-semibold mb-[15px] mx-auto"
          onClick={() => navigate('/login')}
        />
      </div>
      <TermsPolicy />
    </div>
  );
};

export default Success;
